export enum AppLanguage {
    German = "de",
    English = "en",
}

export enum ThemeName {
    Light = "light",
    Dark = "dark",
}

export const REGEX = {
    EMAIL: new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
};
